import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  GetAllTouristDocumentsResponse,
  ReservationsUploadTouristDocumentCreateBody,
  SearchReservationsRequest,
  SearchReservationsResponse
} from '@appTypes/api.types';
import { TRACEPARENT_HEADER } from '@core/interceptors/trace-context';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ReservationsApiService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiEndPoint: string = environment.urls.api + '/Reservations/';

  public getReservations(payload: SearchReservationsRequest) {
    return this.#httpClient.post<SearchReservationsResponse>(this.#apiEndPoint + 'SearchReservations', payload);
  }

  /**
   * Downloads one document. A caller that shows the Trace ID while it waits (the insurance line, C23) passes the `traceparent` it
   * generated - the interceptor keeps a header that is already there and every service continues that trace.
   */
  public getDocument(invoiceUrl: string, traceparent?: string) {
    return this.#httpClient.post(
      environment.urls.api + invoiceUrl,
      {},
      {
        responseType: 'blob',
        observe: 'response',
        ...(traceparent ? { headers: { [TRACEPARENT_HEADER]: traceparent } } : {})
      }
    );
  }
  public uploadTouristDocument(payload: ReservationsUploadTouristDocumentCreateBody) {
    const formData = new FormData();

    if (payload.file && payload.file instanceof File) formData.append('file', payload.file, payload.file.name);
    if (payload.title) formData.append('title', payload.title);
    if (payload.touristId) formData.append('touristId', payload.touristId);
    if (payload.rfid) formData.append('rfid', payload.rfid);

    return this.#httpClient.post(this.#apiEndPoint + `UploadTouristDocument`, formData);
  }
  public getAllTouristDocuments(touristId: string, rfid: string) {
    return this.#httpClient.post<GetAllTouristDocumentsResponse>(this.#apiEndPoint + `GetAllTouristDocuments`, {
      touristId,
      rfid
    });
  }
  public downloadTouristDocument(fileId: string, touristId: string, rfid: string) {
    return this.#httpClient.post(
      this.#apiEndPoint + 'DownloadTouristDocument',
      { fileId, touristId, rfid },
      { responseType: 'blob', observe: 'response' }
    );
  }
  public deleteTouristDocument(fileId: string, touristId: string, rfid: string) {
    return this.#httpClient.delete(this.#apiEndPoint + 'TouristDocument/' + encodeURIComponent(fileId), {
      params: { touristId, rfid }
    });
  }
}
